import React from 'react'
import { Link } from "react-router-dom";

import comingsoon from '../../assets/Images/coming-soon.png'

function Comingsoon() {
  return (
    <div className='coming d-flex flex-column align-items-center justify-content-center text-center gap-3'>
        <figure>
        <img className='w-100' src={comingsoon} alt="comingsoon.img" />
        </figure>
        <h2>We are</h2>
        <h1>Coming Soon</h1>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.</p>
        <Link to = "/" className="btn_1">Back to Home</Link>
    </div>
  )
}

export default Comingsoon
